// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2kekf","footer":"ModalError_footer__3KgDm"};